import { BreakCanvas } from 'classes/break-canvas';
import { BreakView } from 'components/common/break-view';
import { PresetTrainingContext } from 'components/machine/dialogs/preset-training/context';
import { CardPadding0 } from 'components/machine/dialogs/preset-training/controls';
import { AimingContext } from 'contexts/aiming.context';
import { TrainingContext } from 'contexts/training.context';
import { PTStep } from 'enums/training.enums';
import { TrajHelper } from 'lib_ts/classes/trajectory.helper';
import { IMachineShot } from 'lib_ts/interfaces/training/i-machine-shot';
import { useContext } from 'react';

export const PresetTrainingBreaks = (props: {
  lastAimingShot: IMachineShot | undefined;
}) => {
  const { shots: trainingShots } = useContext(TrainingContext);
  const { lastTrainedMs, showFailure, step } = useContext(
    PresetTrainingContext
  );
  const { pitchTraining } = useContext(AimingContext);

  const actual = BreakCanvas.getMedian(
    trainingShots.map((s) => TrajHelper.getBreaksFromShot(s))
  );

  const actual_x_in = actual ? actual.xInches : 0;
  const actual_z_in = actual ? actual.zInches : 0;

  const target = pitchTraining
    ? (pitchTraining.breaks ?? TrajHelper.getBreaks(pitchTraining.traj))
    : undefined;

  const target_x_in = target ? -target.xInches : actual_x_in;
  const target_z_in = target ? target.zInches : actual_z_in;

  return (
    <CardPadding0>
      {pitchTraining && (
        <BreakView
          // forces redraw for new pitch => target moves
          key={`breaks-${pitchTraining._id ?? 'no-id'}`}
          actual_x_in={actual_x_in}
          actual_z_in={actual_z_in}
          target_x_in={target_x_in}
          target_z_in={target_z_in}
          shots={trainingShots}
          newShotID={props.lastAimingShot?._id}
          ptStep={
            // * only change to/from complete to avoid redrawing the target layer constantly
            step === PTStep.Complete && !showFailure
              ? PTStep.Complete
              : undefined
          }
          ptMode={lastTrainedMs?.preset?.mode}
          disabled
          training
        />
      )}
    </CardPadding0>
  );
};
